/** Query keys for the departments table on the entity detail page. */
export const departmentKeys = {
  all: ["departments"],
  lists: () => [...departmentKeys.all, "list"],
  list: ({ entityId = null } = {}) => [...departmentKeys.lists(), { entityId }],
};
